<template>
    <div style="height: 100%;overflow: auto;position: relative">
        <Row>
            <div class="front-flag"></div>
            <div style="font-weight: bold">收银</div>
            <div class="back-button" @click="onClose()">
                <Icon type="ios-undo"/>
                <span>返回上一级</span>
            </div>
            <div class="back-button" style="position: absolute;right: 0;" @click="onClose()">
                <Icon type="md-close"/>
                <span>关闭</span>
            </div>
        </Row>
        <div class="split-line"></div>
        <Row class="base-info">
            <Col span="6" class="form-item-col">
                <span class="form-title">护理单号：</span>
                <span class="form-value">{{ orderInfo.orderNumber }}</span>
            </Col>
            <Col span="6" class="form-item-col">
                <span class="form-title">客户名称：</span>
                <span class="form-value">{{ orderInfo.memberName }}</span>
            </Col>
            <Col span="6" class="form-item-col">
                <span class="form-title">手机号：</span>
                <span class="form-value">{{ orderInfo.memberPhone }}</span>
            </Col>
            <Col span="6" class="form-item-col">
                <span class="form-title">登记日期：</span>
                <span class="form-value">{{ orderInfo.receiveDate }}</span>
            </Col>
        </Row>
        <div class="base-info cashier-info">
            <div style="margin-bottom: 10px">
                <span style="font-weight: bold">选择支付方式：</span>
                <span style="font-size: 12px;color: red">应收：￥{{ orderInfo.receivablePrice }}</span>
            </div>
            <div :class="isWechatActive? 'amount-active' : 'amount-normal'"
                 @mouseleave="wechatPriceLeave()" @click="wechatPriceClick()">
                <div :class="isWechatActive? 'price-title' : 'price-title-normal'">微信</div>
                <div v-if="isWechatActive">
                    <Input size="small" type="number" v-if="wechatPriceShow" v-model="orderInfo.wechatPrice"
                           class="item-price item-price-input" @on-keydown="onMoneyKeyPress"/>
                    <div v-else class="item-price" @click.stop="wechatPriceClick()">￥{{ orderInfo.wechatPrice }}</div>
                </div>
                <div v-if="wechatPriceError" class="price-error">
                    <span>金额最多只能有两位小数</span>
                </div>
            </div>
            <div :class="isAlipayActive? 'amount-active' : 'amount-normal'"
                 @mouseleave="alipayPriceLeave()" @click="alipayPriceClick()">
                <div :class="isAlipayActive? 'price-title' : 'price-title-normal'">支付宝</div>
                <div v-if="isAlipayActive">
                    <Input size="small" type="number" v-if="alipayPriceShow" v-model="orderInfo.alipayPrice"
                           class="item-price item-price-input" @on-keydown="onMoneyKeyPress"/>
                    <div v-else class="item-price" @click.stop="alipayPriceClick()">￥{{ orderInfo.alipayPrice }}</div>
                </div>
                <div v-if="alipayPriceError" class="price-error">
                    <span>金额最多只能有两位小数</span>
                </div>
            </div>
            <div :class="isCashActive? 'amount-active' : 'amount-normal'"
                 @mouseleave="cashPriceLeave()" @click="cashPriceClick()">
                <div :class="isCashActive? 'price-title' : 'price-title-normal'">现金</div>
                <div v-if="isCashActive">
                    <Input size="small" type="number" v-if="cashPriceShow" v-model="orderInfo.cashPrice"
                           class="item-price item-price-input" @on-keydown="onMoneyKeyPress"/>
                    <div v-else class="item-price" @click.stop="cashPriceClick()">￥{{ orderInfo.cashPrice }}</div>
                </div>
                <div v-if="cashPriceError" class="price-error">
                    <span>金额最多只能有两位小数</span>
                </div>
            </div>
            <div :class="isCardActive? 'amount-active' : 'amount-normal'"
                 @mouseleave="cardPriceLeave()" @click="cardPriceClick()">
                <div :class="isCardActive? 'price-title' : 'price-title-normal'">银行卡</div>
                <div v-if="isCardActive">
                    <Input size="small" type="number" v-if="cardPriceShow" v-model="orderInfo.cardPrice"
                           class="item-price item-price-input" @on-keydown="onMoneyKeyPress"/>
                    <div v-else class="item-price" @click.stop="cardPriceClick()">￥{{ orderInfo.cardPrice }}</div>
                </div>
                <div v-if="cardPriceError" class="price-error">
                    <span>金额最多只能有两位小数</span>
                </div>
            </div>
            <div :class="isBalanceActive? 'amount-active' : 'amount-normal'"
                 @mouseleave="balancePriceLeave()" @click="balancePriceClick()">
                <div :class="isBalanceActive? 'price-title' : 'price-title-normal'">余额(￥{{ currentBalance }})</div>
                <div v-if="isBalanceActive">
                    <Input size="small" type="number" v-if="balancePriceShow" v-model="orderInfo.balancePrice"
                           class="item-price item-price-input" @on-keydown="onMoneyKeyPress"/>
                    <div v-else class="item-price" @click.stop="balancePriceClick()">￥{{ orderInfo.balancePrice }}</div>
                </div>
                <div v-if="balancePriceError" class="price-error">
                    <span>金额最多只能有两位小数</span>
                </div>
            </div>
            <div :class="isCreditActive? 'amount-active' : 'amount-normal'"
                 @mouseleave="creditPriceLeave()" @click="creditPriceClick()">
                <div :class="isCreditActive? 'price-title' : 'price-title-normal'">挂账</div>
                <div v-if="isCreditActive">
                    <Input size="small" type="number" v-if="creditPriceShow" v-model="orderInfo.creditPrice"
                           class="item-price item-price-input" @on-keydown="onMoneyKeyPress"/>
                    <div v-else class="item-price" @click.stop="creditPriceClick()">￥{{ orderInfo.creditPrice }}</div>
                </div>
                <div v-if="creditPriceError" class="price-error">
                    <span>金额最多只能有两位小数</span>
                </div>
            </div>
        </div>
        <div class="base-info cashier-info">
            <div style="margin-bottom: 10px">
                <span style="font-weight: bold">收款备注：</span>
            </div>
            <Input type="textarea" placeholder="请输入收款备注" v-model="orderInfo.cashierRemark"/>
        </div>
        <div class="cashier-footer">
            <span style="font-weight: bold">收银时间：</span>
            <span>
                <DatePicker type="datetime" format="yyyy-MM-dd HH:mm:ss" v-model="defaultCashierTime"
                            placeholder="请选择接车时间" class="my-form-input" @on-change="handleCashierChange"/>
            </span>
            <div style="float: right">
                <span>应收：￥
                    <span style="font-size: 12px;color: red">
                        {{ orderInfo.receivablePrice }}
                    </span>
                </span>
                <div class="split-col"></div>
                <span>实收：￥
                    <span style="font-size: 12px;color: red">
                        {{ orderInfo.actualPrice }}
                    </span>
                </span>
                <div class="split-col"></div>
                <span>减免：￥
                    <span style="font-size: 12px;color: red">
                        {{ orderInfo.reducePrice }}
                    </span>
                </span>
                <div class="cashier-button" @click="cashierClick()">
                    确认收银
                </div>
            </div>
        </div>
        <div style="height: 85px"></div>
    </div>
</template>

<script>
import {addActualPrice, subtract} from "@/api/math"
import {queryMemberById} from "@/api/business"
import Decimal from "decimal.js"

export default {
    name: "FacialCashierDetail",
    props: {
        orderInput: {
            type: Object,
        },
    },
    data() {
        return {
            orderInfo: {},
            isCreditActive: false,
            creditPriceShow: false,
            creditPriceError: false,

            isWechatActive: false,
            wechatPriceShow: false,
            wechatPriceError: false,

            isAlipayActive: false,
            alipayPriceShow: false,
            alipayPriceError: false,

            isCashActive: false,
            cashPriceShow: false,
            cashPriceError: false,

            isCardActive: false,
            cardPriceShow: false,
            cardPriceError: false,

            isBalanceActive: false,
            balancePriceShow: false,
            balancePriceError: false,

            defaultCashierTime: new Date(),

            currentBalance: new Decimal(0),
        }
    },
    mounted() {
        this.orderInfo = Object.assign({}, this.orderInput)
        this.queryMember()
        this.initShowInfo()
    },
    methods: {
        onClose() {
            this.$emit('handleClose', false)
        },
        initShowInfo() {
            this.isCreditActive = this.orderInfo.creditPrice > 0
            this.isWechatActive = this.orderInfo.wechatPrice > 0
            this.isAlipayActive = this.orderInfo.alipayPrice > 0
            this.isCashActive = this.orderInfo.cashPrice > 0
            this.isCardActive = this.orderInfo.cardPrice > 0
            this.isBalanceActive = this.orderInfo.balancePrice > 0
        },
        queryMember() {
            queryMemberById({id: this.orderInfo.memberId}).then((res) => {
                if (res.data == null) {
                    this.$Message.error("数据错误，会员不存在")
                } else {
                    this.currentBalance = new Decimal(res.data.balance)
                }
            })
        },
        hasMoreThanTwoDecimals(num) {
            // 正则匹配小数点后超过两位的数字
            return /\.\d{3,}$/.test(num.toString())
        },
        creditPriceClick() {
            if (!this.isCreditActive) {
                this.isCreditActive = true
            }
            this.creditPriceShow = true
            if (!this.orderInfo.creditPrice || this.orderInfo.creditPrice == 0 || this.orderInfo.creditPrice == '') {
                this.orderInfo.creditPrice = this.orderInfo.receivablePrice
                if (this.orderInfo.wechatPrice) {
                    this.orderInfo.creditPrice = subtract(this.orderInfo.creditPrice, this.orderInfo.wechatPrice)
                }
                if (this.orderInfo.alipayPrice) {
                    this.orderInfo.creditPrice = subtract(this.orderInfo.creditPrice, this.orderInfo.alipayPrice)
                }
                if (this.orderInfo.balancePrice) {
                    this.orderInfo.creditPrice = subtract(this.orderInfo.creditPrice, this.orderInfo.balancePrice)
                }
                if (this.orderInfo.cashPrice) {
                    this.orderInfo.creditPrice = subtract(this.orderInfo.creditPrice, this.orderInfo.cashPrice)
                }
                if (this.orderInfo.cardPrice) {
                    this.orderInfo.creditPrice = subtract(this.orderInfo.creditPrice, this.orderInfo.cardPrice)
                }
                if (this.orderInfo.creditPrice < 0) {
                    this.orderInfo.creditPrice = 0
                }
            }
        },
        creditPriceLeave() {
            if (!this.orderInfo.creditPrice || this.orderInfo.creditPrice === '') {
                this.orderInfo.creditPrice = 0
            }
            if (this.hasMoreThanTwoDecimals(this.orderInfo.creditPrice)) {
                this.creditPriceError = true
                return
            }
            this.orderInfo.creditPrice = Number(this.orderInfo.creditPrice)
            this.creditPriceError = false
            this.creditPriceShow = false
            this.isCreditActive = this.orderInfo.creditPrice > 0
            this.orderInfo.actualPrice = this.getActualPrice()
            this.orderInfo.reducePrice = subtract(this.orderInfo.receivablePrice, this.orderInfo.actualPrice)
            this.$forceUpdate()
        },
        wechatPriceClick() {
            if (!this.isWechatActive) {
                this.isWechatActive = true
            }
            this.wechatPriceShow = true
            if (!this.orderInfo.wechatPrice || this.orderInfo.wechatPrice == 0 || this.orderInfo.wechatPrice == '') {
                this.orderInfo.wechatPrice = this.orderInfo.receivablePrice
                if (this.orderInfo.creditPrice) {
                    this.orderInfo.wechatPrice = subtract(this.orderInfo.wechatPrice, this.orderInfo.creditPrice)
                }
                if (this.orderInfo.alipayPrice) {
                    this.orderInfo.wechatPrice = subtract(this.orderInfo.wechatPrice, this.orderInfo.alipayPrice)
                }
                if (this.orderInfo.balancePrice) {
                    this.orderInfo.wechatPrice = subtract(this.orderInfo.wechatPrice, this.orderInfo.balancePrice)
                }
                if (this.orderInfo.cashPrice) {
                    this.orderInfo.wechatPrice = subtract(this.orderInfo.wechatPrice, this.orderInfo.cashPrice)
                }
                if (this.orderInfo.cardPrice) {
                    this.orderInfo.wechatPrice = subtract(this.orderInfo.wechatPrice, this.orderInfo.cardPrice)
                }
                if (this.orderInfo.wechatPrice < 0) {
                    this.orderInfo.wechatPrice = 0
                }
            }
        },
        wechatPriceLeave() {
            if (!this.orderInfo.wechatPrice || this.orderInfo.wechatPrice === '') {
                this.orderInfo.wechatPrice = 0
            }
            if (this.hasMoreThanTwoDecimals(this.orderInfo.wechatPrice)) {
                this.wechatPriceError = true
                return
            }
            this.orderInfo.wechatPrice = Number(this.orderInfo.wechatPrice)
            this.wechatPriceError = false
            this.wechatPriceShow = false
            this.isWechatActive = this.orderInfo.wechatPrice > 0
            this.orderInfo.actualPrice = this.getActualPrice()
            this.orderInfo.reducePrice = subtract(this.orderInfo.receivablePrice, this.orderInfo.actualPrice)
            this.$forceUpdate()
        },
        alipayPriceClick() {
            if (!this.isAlipayActive) {
                this.isAlipayActive = true
            }
            this.alipayPriceShow = true
            if (!this.orderInfo.alipayPrice || this.orderInfo.alipayPrice == 0 || this.orderInfo.alipayPrice == '') {
                this.orderInfo.alipayPrice = this.orderInfo.receivablePrice
                if (this.orderInfo.creditPrice) {
                    this.orderInfo.alipayPrice = subtract(this.orderInfo.alipayPrice, this.orderInfo.creditPrice)
                }
                if (this.orderInfo.wechatPrice) {
                    this.orderInfo.alipayPrice = subtract(this.orderInfo.alipayPrice, this.orderInfo.wechatPrice)
                }
                if (this.orderInfo.balancePrice) {
                    this.orderInfo.alipayPrice = subtract(this.orderInfo.alipayPrice, this.orderInfo.balancePrice)
                }
                if (this.orderInfo.cashPrice) {
                    this.orderInfo.alipayPrice = subtract(this.orderInfo.alipayPrice, this.orderInfo.cashPrice)
                }
                if (this.orderInfo.cardPrice) {
                    this.orderInfo.alipayPrice = subtract(this.orderInfo.alipayPrice, this.orderInfo.cardPrice)
                }
                if (this.orderInfo.alipayPrice < 0) {
                    this.orderInfo.alipayPrice = 0
                }
            }
        },
        alipayPriceLeave() {
            if (!this.orderInfo.alipayPrice || this.orderInfo.alipayPrice === '') {
                this.orderInfo.alipayPrice = 0
            }
            if (this.hasMoreThanTwoDecimals(this.orderInfo.alipayPrice)) {
                this.alipayPriceError = true
                return
            }
            this.orderInfo.alipayPrice = Number(this.orderInfo.alipayPrice)
            this.alipayPriceError = false
            this.alipayPriceShow = false
            this.isAlipayActive = this.orderInfo.alipayPrice > 0
            this.orderInfo.actualPrice = this.getActualPrice()
            this.orderInfo.reducePrice = subtract(this.orderInfo.receivablePrice, this.orderInfo.actualPrice)
            this.$forceUpdate()
        },
        cashPriceClick() {
            if (!this.isCashActive) {
                this.isCashActive = true
            }
            this.cashPriceShow = true
            if (!this.orderInfo.cashPrice || this.orderInfo.cashPrice == 0 || this.orderInfo.cashPrice == '') {
                this.orderInfo.cashPrice = this.orderInfo.receivablePrice
                if (this.orderInfo.creditPrice) {
                    this.orderInfo.cashPrice = subtract(this.orderInfo.cashPrice, this.orderInfo.creditPrice)
                }
                if (this.orderInfo.wechatPrice) {
                    this.orderInfo.cashPrice = subtract(this.orderInfo.cashPrice, this.orderInfo.wechatPrice)
                }
                if (this.orderInfo.balancePrice) {
                    this.orderInfo.cashPrice = subtract(this.orderInfo.cashPrice, this.orderInfo.balancePrice)
                }
                if (this.orderInfo.alipayPrice) {
                    this.orderInfo.cashPrice = subtract(this.orderInfo.cashPrice, this.orderInfo.alipayPrice)
                }
                if (this.orderInfo.cardPrice) {
                    this.orderInfo.cashPrice = subtract(this.orderInfo.cashPrice, this.orderInfo.cardPrice)
                }
                if (this.orderInfo.cashPrice < 0) {
                    this.orderInfo.cashPrice = 0
                }
            }
        },
        cashPriceLeave() {
            if (!this.orderInfo.cashPrice || this.orderInfo.cashPrice === '') {
                this.orderInfo.cashPrice = 0
            }
            if (this.hasMoreThanTwoDecimals(this.orderInfo.cashPrice)) {
                this.cashPriceError = true
                return
            }
            this.orderInfo.cashPrice = Number(this.orderInfo.cashPrice)
            this.cashPriceError = false
            this.cashPriceShow = false
            this.isCashActive = this.orderInfo.cashPrice > 0
            this.orderInfo.actualPrice = this.getActualPrice()
            this.orderInfo.reducePrice = subtract(this.orderInfo.receivablePrice, this.orderInfo.actualPrice)
            this.$forceUpdate()
        },
        cardPriceClick() {
            if (!this.isCardActive) {
                this.isCardActive = true
            }
            this.cardPriceShow = true
            if (!this.orderInfo.cardPrice || this.orderInfo.cardPrice == 0 || this.orderInfo.cardPrice == '') {
                this.orderInfo.cardPrice = this.orderInfo.receivablePrice
                if (this.orderInfo.creditPrice) {
                    this.orderInfo.cardPrice = subtract(this.orderInfo.cardPrice, this.orderInfo.creditPrice)
                }
                if (this.orderInfo.wechatPrice) {
                    this.orderInfo.cardPrice = subtract(this.orderInfo.cardPrice, this.orderInfo.wechatPrice)
                }
                if (this.orderInfo.balancePrice) {
                    this.orderInfo.cardPrice = subtract(this.orderInfo.cardPrice, this.orderInfo.balancePrice)
                }
                if (this.orderInfo.alipayPrice) {
                    this.orderInfo.cardPrice = subtract(this.orderInfo.cardPrice, this.orderInfo.alipayPrice)
                }
                if (this.orderInfo.cashPrice) {
                    this.orderInfo.cardPrice = subtract(this.orderInfo.cardPrice, this.orderInfo.cashPrice)
                }
                if (this.orderInfo.cardPrice < 0) {
                    this.orderInfo.cardPrice = 0
                }
            }
        },
        cardPriceLeave() {
            if (!this.orderInfo.cardPrice || this.orderInfo.cardPrice === '') {
                this.orderInfo.cardPrice = 0
            }
            if (this.hasMoreThanTwoDecimals(this.orderInfo.cardPrice)) {
                this.cardPriceError = true
                return
            }
            this.orderInfo.cardPrice = Number(this.orderInfo.cardPrice)
            this.cardPriceError = false
            this.cardPriceShow = false
            this.isCardActive = this.orderInfo.cardPrice > 0
            this.orderInfo.actualPrice = this.getActualPrice()
            this.orderInfo.reducePrice = subtract(this.orderInfo.receivablePrice, this.orderInfo.actualPrice)
            this.$forceUpdate()
        },
        balancePriceClick() {
            if (!this.isBalanceActive) {
                this.isBalanceActive = true
            }
            this.balancePriceShow = true
            if (!this.orderInfo.balancePrice || this.orderInfo.balancePrice == 0 || this.orderInfo.balancePrice == '') {
                this.orderInfo.balancePrice = this.orderInfo.receivablePrice
                if (this.orderInfo.creditPrice) {
                    this.orderInfo.balancePrice = subtract(this.orderInfo.balancePrice, this.orderInfo.creditPrice)
                }
                if (this.orderInfo.wechatPrice) {
                    this.orderInfo.balancePrice = subtract(this.orderInfo.balancePrice, this.orderInfo.wechatPrice)
                }
                if (this.orderInfo.cardPrice) {
                    this.orderInfo.balancePrice = subtract(this.orderInfo.balancePrice, this.orderInfo.cardPrice)
                }
                if (this.orderInfo.alipayPrice) {
                    this.orderInfo.balancePrice = subtract(this.orderInfo.balancePrice, this.orderInfo.alipayPrice)
                }
                if (this.orderInfo.cashPrice) {
                    this.orderInfo.balancePrice = subtract(this.orderInfo.balancePrice, this.orderInfo.cashPrice)
                }
                if (this.orderInfo.balancePrice < 0) {
                    this.orderInfo.balancePrice = 0
                }
            }
        },
        balancePriceLeave() {
            if (!this.orderInfo.balancePrice || this.orderInfo.balancePrice === '') {
                this.orderInfo.balancePrice = 0
            }
            if (this.hasMoreThanTwoDecimals(this.orderInfo.balancePrice)) {
                this.balancePriceError = true
                return
            }
            this.orderInfo.balancePrice = Number(this.orderInfo.balancePrice)
            this.balancePriceError = false
            this.balancePriceShow = false
            this.isBalanceActive = this.orderInfo.balancePrice > 0
            this.orderInfo.actualPrice = this.getActualPrice()
            this.orderInfo.reducePrice = subtract(this.orderInfo.receivablePrice, this.orderInfo.actualPrice)
            this.$forceUpdate()
        },
        handleCashierChange(date) {
            this.defaultCashierTime = date
            this.orderInfo.cashierTime = date
        },
        getActualPrice() {
            return addActualPrice(this.orderInfo.creditPrice, this.orderInfo.wechatPrice, this.orderInfo.alipayPrice,
                this.orderInfo.cashPrice, this.orderInfo.cardPrice, this.orderInfo.balancePrice)
        },
        onMoneyKeyPress(event) {
            const key = event.key
            let currentValue = event.target.value
            // 允许的按键：数字（0-9）、小数点（.）、退格（Backspace）
            const allowedKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."]
            const alwaysAllowedKeys = ["Backspace", "Tab", "Enter"]
            if (alwaysAllowedKeys.includes(key)) {
                return
            }
            // 如果按下的键不在允许范围内，阻止输入
            if (!allowedKeys.includes(key)) {
                event.preventDefault()
                return
            }

            // 如果输入的是小数点（.），检查是否已经存在小数点
            if (key === ".") {
                if (currentValue.includes(".")) {
                    event.preventDefault()
                    return
                }
            }

            // 如果已经输入了小数点，检查是否超过两位小数
            if (currentValue.includes(".")) {
                const decimalPart = currentValue.split(".")[1]
                if (decimalPart && decimalPart.length >= 3) {
                    event.preventDefault()
                }
            }
        },
        cashierClick() {
            if (this.orderInfo.actualPrice === undefined) {
                this.$Message.warning('实收金额为空，请先填写金额')
                return
            }
            if (this.orderInfo.balancePrice > 0) {
                if (this.currentBalance.comparedTo(new Decimal(this.orderInfo.balancePrice)) < 0) {
                    this.$Message.error('余额不足，请选择其他方式付款')
                    return
                }
            }
            if (this.orderInfo.actualPrice == 0 || this.orderInfo.actualPrice == "0.00") {
                this.$Modal.confirm({
                    title: '确认收银',
                    content: '<p>实收金额为0，确定完成收银吗？</p>',
                    onOk: () => {
                        this.$emit('handleClose', this.orderInfo)
                    },
                })
            } else if (this.orderInfo.reducePrice > 0) {
                this.$Modal.confirm({
                    title: '确认收银',
                    content: '<p>有减免金额，确定要减免吗？</p>',
                    onOk: () => {
                        this.$emit('handleClose', this.orderInfo)
                    },
                })
            } else {
                this.$Modal.confirm({
                    title: '确认收银',
                    content: '<p>确认收银吗？</p>',
                    onOk: () => {
                        this.$emit('handleClose', this.orderInfo)
                    },
                })
            }
        },
    },
}
</script>

<style scoped>
.front-flag {
    width: 2px;
    background: #2d8cf0;
    margin-right: 10px;
}

.back-button {
    border: 1px solid #e6e6e6;
    font-size: 12px;
    padding: 2px 10px;
    position: relative;
    top: -0;
    border-radius: 3px;
    cursor: pointer;
    margin-left: 10px;
}

.split-line {
    height: 1px;
    background: #dcdcdc;
    margin: 20px 0;
}

.base-info {
    border: 1px solid #e6e6e6;
    padding: 0 20px 30px 20px;
}

.form-title {
    text-align: right;
    display: inline-block;
    width: 80px;
}

.form-value {
    font-weight: bold;
    margin-left: 10px;
}

.form-item-col {
    margin-top: 20px;
}

.cashier-info {
    margin-top: 20px;
    padding-top: 20px;
}

.amount-normal {
    height: 80px;
    width: 150px;
    border: 1px solid #e6e6e6;
    position: relative;
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
}

.amount-active {
    height: 80px;
    width: 150px;
    border: 1px solid #5FB878;
    position: relative;
    cursor: pointer;
    display: inline-block;
    vertical-align: top;
    margin-right: 20px;
}

.amount-active::after {
    content: '';
    position: absolute;
    top: 0;
    right: 0;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 15px 15px 0; /* 调整第二个值改变三角大小 */
    border-color: transparent #5FB878 transparent transparent; /* 第二个值是三角颜色 */
}

.price-title {
    margin: 5px 10px;
    font-size: 13px;
    font-weight: bold;
}

.item-price {
    color: #FAA733;
    position: absolute;
    left: 10px;
    bottom: 5px;
    right: 5px;
}

.item-price-input {
    width: 125px;
}

.price-title-normal {
    text-align: center;
    font-size: 14px;
    font-weight: bold;
    line-height: 75px;
}

.cashier-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    right: 0;
    height: 65px;
    background: #f3f7fd;
    line-height: 65px;
    padding-left: 20px;
    padding-right: 20px;
    box-shadow: 0 -2px 10px -2px rgba(0, 0, 0, 0.2);
}

.split-col {
    display: inline-block;
    height: 45px;
    width: 1px;
    background: #959595;
    vertical-align: top;
    margin: 10px 10px 0 10px;
}

.cashier-button {
    background: #5cb85c;
    color: #ffffff;
    display: inline-block;
    width: 120px;
    text-align: center;
    margin-left: 40px;
    cursor: pointer;
}

.price-error {
    position: absolute;
    color: red;
    font-size: 10px;
    left: 2px;
    bottom: -22px;
}
</style>
